import $ from "jquery";

export interface GoTopButtonOptions {
    breakPoint?: number;
    scrollSpeed?: number;
}

export class GoTopButtonComponent {
    private $currentContext: JQuery = $();
    private $element: JQuery = $();

    private readonly eventNamespace = ".goTopButton";

    private readonly moduleOptions: Required<GoTopButtonOptions> = {
        breakPoint: 800,
        scrollSpeed: 250
    };

    private readonly classMap = {
        button: ".js-go-top-button",
        skipLink: "#skip_to_main_content"
    };

    public init(context?: JQuery, options?: GoTopButtonOptions): void {
        this.$currentContext = context ?? this.$currentContext;
        $.extend(this.moduleOptions, options);

        this.initContext();
        this.bindEvents();
        this.setVisibility();
    }

    private setVisibility(): void {
        const currentPosition = this.$currentContext.scrollTop() ?? 0;
        const isVisible = currentPosition > this.moduleOptions.breakPoint;

        this.$element.toggleClass("pcg-go-top-button--visible", isVisible);
    }

    private initContext(): void {
        this.$element = $(this.classMap.button, this.$currentContext);
    }

    private focusSkipLinkOnNextTab(): void {
        const $document = $(document);
        const keydownEventName = `keydown${this.eventNamespace}`;

        $document.off(keydownEventName);
        $document.one(keydownEventName, (event: JQuery.KeyDownEvent) => {
            if (event.key !== "Tab" || event.shiftKey || event.defaultPrevented) {
                return;
            }

            const $skipLink = $(this.classMap.skipLink);

            if (!$skipLink.length) {
                return;
            }

            event.preventDefault();
            $skipLink.trigger("focus");
        });
    }

    private bindEvents(): void {
        this.$currentContext.off(`scroll${this.eventNamespace}`);
        this.$element.off(`click${this.eventNamespace}`);

        this.$currentContext.on(`scroll${this.eventNamespace}`, () => {
            this.setVisibility();
        });

        this.$element.on(`click${this.eventNamespace}`, (e) => {
            e.preventDefault();

            void $("html, body")
                .animate({ scrollTop: 0 }, this.moduleOptions.scrollSpeed)
                .promise()
                .done(() => {
                    this.$element.trigger("blur");
                    this.focusSkipLinkOnNextTab();
                });
        });
    }
}
